<template>
    <div>
        <el-dialog title="用户详情" :visible.sync="dialogVisible" width="500px">
            <div class="wapper" v-if="userInfo != null">
               <div class="info-top-wapper">
                   <div>
                       <img :src="userInfo.avatar">
                   </div>
                   <div>
                       <span class="info-name">{{userInfo.name}}</span>
                       <span class="info-position">{{userInfo.position}}</span>
                   </div>
               </div>
               <ul class="detail-wapper">
                    <li>
                        <span class="detail-title">手机</span>
                        <span>{{userInfo.mobile}}</span>
                    </li>
                    <li>
                        <span class="detail-title">邮箱</span>
                        <span>{{userInfo.email}}</span>
                    </li>
                    <li>
                       <span class="detail-title">系统角色</span>
                       <span>{{userInfo.reloInfo == null  ? '未设置角色' : userInfo.reloInfo.name}}</span>
                   </li>
                   <li>
                       <span class="detail-title">账号</span>
                       <span>{{userInfo.account}}</span>
                   </li>
                   <li>
                       <span class="detail-title">座机</span>
                       <span>{{userInfo.telephone}}</span>
                   </li>
                   <li>
                       <span class="detail-title">所属部门</span>
                       <span class="detail-department">
                           <span v-for="item in userInfo.departmentInfos" :key="item.departmentId">{{item.name}}</span>
                       </span>
                   </li>
                   <li>
                       <span class="detail-title">当前部门</span>
                       <span>{{userInfo.currDepartmentInfo.name}}</span>
                   </li>
                   <li>
                       <span class="detail-title">身份</span>
                       <span>{{userInfo.currDepartmentInfo.isLeaderInDept == 0 ? '普通成员' : '上级'}}</span>
                   </li>
               </ul>
            </div>
            <!-- <div class="bottom-wapper" v-auth="'edit'">
                <el-button plain @click="setPassword">设置密码</el-button>
                <el-button plain @click="setRole">设置角色</el-button>
            </div> -->
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                dialogVisible: false,
                userInfo: null
            }
        },
        methods: {
            show (info) {
                this.dialogVisible = true
                this.userInfo = info
            },
            setPassword () {
                this.dialogVisible = false
                this.$emit('setPassword', this.userInfo)
            },
            setRole () {
                this.dialogVisible = false
                this.$emit('setRole', this.userInfo)
            }
        }
    }
</script>

<style scoped>
.info-top-wapper{
    margin-bottom: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid #d6dbe5;
}
.info-top-wapper div{
    display: inline-block;
    margin-right: 15px;
}
.info-top-wapper span{
    display: block;
}
.info-name {
    font-size: 18px;
}
.info-top-wapper img{
    width: 80px;
    border: 1px solid #d6dbe5;
    border-radius: 3px;
}
.detail-wapper{
    margin-bottom: 15px;
    border-bottom: 1px solid #d6dbe5;
}
.detail-wapper .detail-title{
    display: inline-block;
    width: 100px;
    text-align: left;
    color: #909399;
}
.detail-wapper li{
    margin: 15px 0;
}
.detail-department span{
    margin-right: 15px;
}
</style>